var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    width: 15.256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.236 5.174-9.659 3.449v5.339l.571.2-.86 1.719a1.525 1.525 0 0 0 .882 2.13l3.115 1.038a1.537 1.537 0 0 0 1.846-.765l.994-1.988 3.111 1.112a.763.763 0 0 0 1.02-.719v-10.797a.763.763 0 0 0 -1.019-.718zm-5.47 12.432-3.114-1.038.942-1.885 3.083 1.1-.911 1.821zm-7.24-3.643h1.525v-5.34h-1.525a1.527 1.527 0 0 0 -1.526 1.526v2.288a1.527 1.527 0 0 0 1.526 1.526z",
    fill: "#3c2f87",
    transform: "translate(-3 -5.129)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.7948fb511e42ae1879783ba043d7a571.svg";
export { ForwardRef as ReactComponent };